import { useEffect } from 'react'

const GTM_ID = import.meta.env.VITE_GTM_ID

export const GTM_ENABLED = GTM_ID !== undefined && GTM_ID !== ''

let gtmLoaded = false

export function GoogleTagManager(): null {
  useEffect(() => {
    if (!GTM_ENABLED || gtmLoaded) return

    gtmLoaded = true

    window.dataLayer = window.dataLayer ?? []
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
    document.head.appendChild(script)
  }, [])

  return null
}
